import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class TicketsAndGuestsStateService{
    public selectedTab: string | null = null;
    public selectedCampaignId: string | null = null;
    public selectedCampaign: string | null = null;
}